import axios from "@/libs/api.request";

export const getConfoList = ({intercom}) => {

  const data = {
    intercom
  }
  return axios.request({
    url:'/api/20190821/infs/getConfoList.json',
    data,
    method:'post'
  })
}
export const getConfoDetailList = ({intercom,confno}) => {
  const data = {
    intercom,
    confno
  }
  return axios.request({
    url:'/api/20190821/infs/getConfoDetailList.json',
    data,
    method:'post'
  })
}
export const getConfoExtenList = ({type}) => {
  const data = {
    type
  }
  return axios.request({
    url:'/api/20190821/infs/getConfoExtenList.json',
    data,
    method:'post'
  })
}
/**
 * 获取不带分区的会议室
 * @param form
 * @returns {*}
 */
export const getConfWithoutDept = ({userId,auth}) => {
  return axios.request({
    url:'/api/api_v2.2.5/conference/query/queryAllForNoPage.json',
    data: {
      userId:userId
    },
    method:'post',
  })
}

/**
 * 获取固定会议室成员，包含临时的（开会中的视频会议室的摄像头、调度员需要去视频会议系统获取）
 * @param confNo
 * @param confName
 * @returns {*}
 */
export const getConferenceMembers = (confNo, confName) => {
  const params = {
    confId:confNo,
    confName:confName
  }
  return axios.request({
    url:'/system-service/api-v2.0/conference/members',
    params,
    method:'get'
  })
}

/**
 * 获取临时会议室成员
 * @param confName
 * @returns {*}
 */
export const getTempConferenceMembers = (confName) => {
  const data = {confName:confName}
  return axios.request({
    url:'/system-service/api-v2.0/conference/temp/members',
    data,
    method:'post'
  })
}

/**
 * 获取视频会议临时成员
 * @param arr
 * @returns {*}
 */
export const getVcsMembers = (arr) => {
  const data = arr
  return axios.request({
    url:'/system-service/api-v2.0/conference/vcs/members',
    data,
    method:'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/conferencejs.js